import React, { useEffect, useMemo, useState } from 'react';
import SearchSingleSelect from '@/pages/datalab/components/SearchSingleSelect';
import bigQuery from '@/pages/datalab/assets/svg/big-query.svg';
import starRocks from '@/pages/datalab/assets/svg/star-rocks.svg';
import postgres from '@/pages/datalab/assets/svg/post-gres.svg';
import clickHouse from '@/pages/datalab/assets/svg/click-house.svg';
import DatSetResult from '../DatSetResult';
import type { IGetTableInfoDto } from '@dbl/services/dataSource';
import { getDatabaseSelect, getTableInfoSelect } from '@dbl/services/dataSource';
import { useDblIntl } from '@/pages/datalab/utils/utils';
import { LeftDataSelectType } from '../_type';
import { shallowEqual, useSelector } from 'umi';
import { SearchBox } from 'tea-component';
import './index.scss';
import Abnormal from '@/pages/home/components/Abnormal';
import { isEmpty } from 'lodash-es';
import DatabaseSelectWithOptionBubble from './DatabaseSelectWithOptionBubble';

const databaseIcon = {
  bigquery: bigQuery,
  postgres,
  starrocks: starRocks,
  clickhouse: clickHouse
};

const LeftDataSelect = (props: LeftDataSelectType) => {
  const { getLeftParams, editConfig, tableDataRef ,sheetLoading, setSheetLoadig} = props;
  const { isFromEdit, editInitData } = editConfig || {};

  const gameCode = useSelector((state: any) => state?.datalab?.gameCode, shallowEqual);
  const { formatMessage, commonFormatMessage, isEn } = useDblIntl('multi');
  const [dataBaseData, setDataBaseData] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>();
  const [databaseValue, setDatabaseValue] = useState('');
  const [dataBaseOptions, setDataBaseOptions] = useState<any[]>([]);
  const [schemaOptions, setSchemaOptions] = useState<any[]>([]);
  const [schemaValue, setSchemaValue] = useState('');
  const [dataAllSheetList, setDataAllSheetList] = useState<any[]>([]);
  const [keyword, setKeyword] = useState<string | undefined>('');
  // 这个状态挪到父级来管理，强制触发更新，渲染UI
  // const [sheetLoading, setSheetLoadig] = useState(true)
  const [sheetError, setSheetError] = useState(false);
  const [firstSeleted, setFirstSlected] = useState<IGetTableInfoDto>({});
  const [dataBaseLoading, setDataBaseLoading] = useState(true);
  const [dataBaseError, setDataBaseError] = useState('');

  useEffect(() => {
    const { databaseValue, schemaValue } = editInitData || {};
    if (!isFromEdit || !databaseValue || !schemaValue) return;
    getDatabaseSelect({ game_code: gameCode }).then((res: any) => {
      setDataBaseLoading(false);
      setDataBaseError('');
      if (res?.[0]) {
        setDataBaseData(res || []);
        setDataBaseOptions(getDataBaseOptions(res || []));
        setSchemaOptions(getSchemaOptions(res || [], databaseValue));
        setDatabaseValue(databaseValue);
        setSchemaValue(schemaValue);
        getLeftParams({
          databaseValue,
          schemaValue: schemaValue || '',
          firstSeleted,
        });
        getDataResult(databaseValue, schemaValue || '');

      }
    }).catch(e => {
      setDataBaseLoading(false);
      setDataBaseError(e);
    });
  }, [JSON.stringify(editConfig)]);

  useEffect(() => {
    if (isFromEdit) return;
    getDatabaseSelect({ game_code: gameCode }).then((res: any) => {
      setDataBaseLoading(false);
      setDataBaseError('');
      if (res?.[0]) {
        const { database_uuid: databaseUuid, schema } = res[0];
        setDataBaseData(res || []);
        setDataBaseOptions(getDataBaseOptions(res || []));
        setSchemaOptions(getSchemaOptions(res || [], databaseUuid));
        if (!isFromEdit) {
          setDatabaseValue(databaseUuid);
          setSchemaValue(schema?.[0] || '');
          getLeftParams({
            databaseValue: databaseUuid,
            schemaValue: schema?.[0] || '',
            firstSeleted,
          });
          getDataResult(databaseUuid, schema?.[0] || '');
        }
      }
    }).catch(e => {
      setDataBaseLoading(false);
      setDataBaseError(e);
    });
  }, [gameCode]);

  const getDataResult = (databaseUuid, schema) => {
    setSheetLoadig(true);
    setSheetError(false);
    getTableInfoSelect({
      game_code: gameCode,
      database_uuid: databaseUuid,
      schema: schema || ''
    }).then((res) => {
      setDataAllSheetList(res || []);
      // setDataSheetList(res || [])
      setSheetLoadig(false);
    }).catch((e) => {
      setSheetLoadig(false);
      setSheetError(true);
    });
  };

  const dataSheetList = useMemo(() => {
    const dataSheet = dataAllSheetList?.filter(item => {
      const columnListName = item?.column_list?.map(items => items?.name) || [];
      return item?.table_name?.includes(keyword) || JSON.stringify(columnListName)?.includes(keyword);
    }) || [];
    return dataSheet;
  }, [dataAllSheetList, keyword]);

  function mergeNames(data: any[]) {
    if (isEmpty(data)) return [];
    const list = [];
    data.map(task => {
      list.push({
        value: task.table_name,
        meta: 'table',
      });
      task.column_list.map((item) => {
        list.push({
          value: item.name,
          meta: 'field',
        });
      }
      );
    });
    return list;
  }
  useEffect(() => {
    if (!isEmpty(dataSheetList)) {
      const cloneDeepData = [...dataSheetList];
      const dataSource = mergeNames(cloneDeepData);
      tableDataRef.current = dataSource;
    }
  }, [dataSheetList]);
  
  const getDataBaseOptions = (data) => {
    const dataBaseOptionsData = data?.map(item => ({
      value: item?.database_uuid,
      label: item?.database_name,
      databaseName: item?.database_name,
      driver: item?.driver,
      schema: item?.schema,
      host: item?.host,
      port: item?.port,
      text:
          <div className="dbl-options-text-box" key={item?.database_uuid}>
            <img
              className="dbl-options-text-box-icon"
              src={databaseIcon?.[item?.driver]}
              alt=""
            />
            <span
              className="dbl-options-text-box-text"
              dangerouslySetInnerHTML={{
                __html: item?.database_name,
              }}
            />
          </div>,
    }));
    return dataBaseOptionsData;
  };

  const getSchemaOptions = (data, dataValue) => {
    if (!dataValue) return [];
    let schemaOptionsData: { value: any; }[] = [];
    data?.forEach(item => {
      if (item?.database_uuid === dataValue) {
        schemaOptionsData = item?.schema?.map(items => ({
          value: items,
          label: items,
          text: items,
        }));
      }
    });
    return schemaOptionsData;
  };

  const handleDatabaseChange = (val: string) => {
    setDatabaseValue(val);
    const schemaOptionsData = getSchemaOptions(dataBaseData, val);
    const schemaValueData = schemaOptionsData?.[0]?.value || '';
    setSchemaValue(schemaValueData);
    setSchemaOptions(schemaOptionsData);
    getDataResult(val, schemaValueData);
    getLeftParams({
      databaseValue: val,
      schemaValue: schemaValueData,
      firstSeleted,
    });
  };

  const handleSchemaChange = (val: string) => {
    setSchemaValue(val);
    getDataResult(databaseValue, val);
    getLeftParams({
      databaseValue,
      schemaValue: val,
      firstSeleted,
    });
  };

  const getFilrstSelecteTable = (obj: IGetTableInfoDto) => {
    setFirstSlected(obj);
    getLeftParams({
      databaseValue,
      schemaValue,
      firstSeleted: obj,
    });
  };

  return (
    <div className='dbl-drag-add-sourse-left'>
      {/* const {selectorName,selectorPlaceholder,searchPlaceholder} = infoConfig || {} */}
      <div className='dbl-drag-add-filter-box'>
        <div className='dbl-drag-add-sourse-left-filter dbl-drag-add-sourse-left-filter-border'>
          <div className='dbl-drag-single-selector-label'>
            {formatMessage({ id: 'dbl_sql_add_database' })}
          </div>
          <DatabaseSelectWithOptionBubble
            selectorName={formatMessage({ id: 'dbl_sql_add_database' })}
            loading={dataBaseLoading}
            error={dataBaseError}
            options={dataBaseOptions}
            className='dbl-drag-add-sourse-left-single-filter'
            infoConfig={{
              selectorName: formatMessage({ id: 'dbl_sql_add_database' }),
              selectorPlaceholder: formatMessage({ id: 'dbl_sql_add_search_database' }),
              searchPlaceholder: formatMessage({ id: 'dbl_sql_add_search_database' }),
            }}
            value={databaseValue}
            onChange={handleDatabaseChange}
            formatMessage={formatMessage}
            selectProps={{ listWidth: 322 }}
          />
        </div>
        <div className='dbl-drag-add-sourse-left-filter'>
          <div className='dbl-drag-single-selector-label'>
            {formatMessage({ id: 'dbl_sql_add_schema' })}
          </div>
          <SearchSingleSelect
            options={schemaOptions}
            loading={dataBaseLoading}
            error={dataBaseError}
            value={schemaValue}
            className='dbl-drag-add-sourse-left-single-filter'
            infoConfig={{
              selectorName: formatMessage({ id: 'dbl_sql_add_schema' }),
              selectorPlaceholder: formatMessage({ id: 'dbl_sql_add_search_schema' }),
              searchPlaceholder: formatMessage({ id: 'dbl_sql_add_search_schema' }),
            }}
            onChange={handleSchemaChange}
            selectProps={{ listWidth: 322 }}
          />
        </div>
        <div className='dbl-drag-add-sourse-left-filter'>
          <div className='dbl-drag-single-selector-label'>
            {formatMessage({ id: 'dbl_sql_add_dataset' })}
          </div>
          <SearchBox
            className="dbl-drag-search-box"
            value={searchValue}
            onChange={(value) => {
              setSearchValue(value);
              setKeyword(value);
            }}
            onSearch={(keywords: string | undefined) => {
              setKeyword(keywords);
            }}
            onClear={() => {
              setKeyword('');
            }}
            placeholder={formatMessage({ id: 'dbl_sql_add_search_dataset' })}
          />
        </div>
      </div>
      <div className='dbl-drag-add-filter-result'>
        <Abnormal
          isLoading={sheetLoading}
          isError={sheetError}
          nodataMsg={commonFormatMessage("no_data")}
          isNoData={dataSheetList?.length === 0}
          component={<DatSetResult dataSetData={dataSheetList} getFilrstSelecteTable={getFilrstSelecteTable} />}
        />
      </div>

    </div>
  );
};

export default LeftDataSelect;
